export default function LoadingState({ label = "内容加载中…" }: { label?: string }) {
  return (
    <div className="py-20 flex flex-col items-center justify-center text-foreground-500">
      <span className="w-10 h-10 rounded-full border-2 border-background-200 border-t-accent-500 animate-spin"></span>
      <p className="mt-4 text-sm">{label}</p>
    </div>
  );
}